import {Label} from "../../../basic/label";
import {TeamMemberItem} from "./TeamMemberItem";
import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";
import {VwpLicense, VwpTeamMember} from "../../../../store/generated/api";

interface TeamMembersListProps {
    teamMembers: VwpTeamMember[];
    availableLicenses: VwpLicense[];
    managingMemberId: number | null;
    isAssigningLicense?: boolean;
    isRemovingLicense?: boolean;
    onToggleManageMember: (memberId: number) => void;
    onAssignLicense: (licenseId: string, licenseName: string, memberEmail: string, memberName: string) => void;
    onRemoveLicense: (licenseId: string, licenseName: string, memberEmail: string, memberName: string) => void;
    onRemoveMember: (memberEmail: string, memberName: string) => void;
}

export function TeamMembersList({
                                    teamMembers,
                                    availableLicenses,
                                    managingMemberId,
                                    isAssigningLicense = false,
                                    isRemovingLicense = false,
                                    onToggleManageMember,
                                    onAssignLicense,
                                    onRemoveLicense,
                                    onRemoveMember
                                }: TeamMembersListProps) {
    const {t} = useTranslationWithKeys();

    return (
        <div className="space-y-4 pt-4 border-t">
            <Label>{t('admin.teams.teamManagement.teamMembers', {count: teamMembers.length})}</Label>
            <div className="space-y-3">
                {teamMembers.map((member) => (
                    <TeamMemberItem
                        key={member.id}
                        member={member}
                        availableLicenses={availableLicenses}
                        isManagingMember={managingMemberId === member.id}
                        isAssigningLicense={isAssigningLicense}
                        isRemovingLicense={isRemovingLicense}
                        onToggleManageMember={() => onToggleManageMember(member.id)}
                        onAssignLicense={onAssignLicense}
                        onRemoveLicense={onRemoveLicense}
                        onRemoveMember={onRemoveMember}
                    />
                ))}
                {teamMembers.length === 0 && (
                    <p className="text-muted-foreground p-3">{t('admin.teams.teamManagement.noMembers')}</p>
                )}
            </div>
        </div>
    );
}